/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import { getLighthouseMetrics } from '@atlaskit/react-ufo/getLighthouseMetrics'` instead.
 */
export { getLighthouseMetrics } from './utils/lighthouse-metrics/getLighthouseMetrics';
/**
 * @deprecated Use `import { startLighthouseObserver } from '@atlaskit/react-ufo/startLighthouseObserver'` instead.
 */
export { startLighthouseObserver } from './utils/lighthouse-metrics/startLighthouseObserver';
/**
 * @deprecated Use `import { getCacheHitRatio } from '@atlaskit/react-ufo/additional-payload/cache-hit-ratio'` instead.
 */
export { getCacheHitRatio } from './utils/cache-hit-ratio';
